import { View } from '@react-pdf/renderer';
import { globalStyles } from 'PDF/styles';
import { ITimelineItem } from 'PDF/types/timeline';

import { Legend } from './Legend';
import { getHeaderDates, getTimelineGroups } from './utils';
import { ProgressHeader } from '../ProgressTable/ProgressHeader';
import { ProgressRow } from '../ProgressTable/ProgressRow';

interface IProps {
  items: ITimelineItem[];
  withLegend?: boolean;
  firstColumnWidth?: number;
  isExamplePage: boolean;
}

const TYPE = 'month';

export const DevelopmentTimelineTable = ({
  items,
  withLegend = true,
  firstColumnWidth = 90,
  isExamplePage,
}: IProps) => {
  const dates = getHeaderDates(TYPE, items);
  const groupedItems = getTimelineGroups(items);

  return (
    <View style={globalStyles.marginBottom}>
      <ProgressHeader date={dates} paddingLeft={`${firstColumnWidth}px`} />
      {groupedItems.map((item, index) => (
        <>
          <View minPresenceAhead={150} />
          <ProgressRow key={index} item={item} dates={dates} width={firstColumnWidth} type={TYPE} />
        </>
      ))}
      {withLegend && <Legend isExamplePage={isExamplePage} />}
    </View>
  );
};
